export default  {
 "title" : "城市共享两轮车监管平台",
 "main" : "139",
 "daylist" : "69",
 "monthlist" : "134",
 "totallist" : "72",
 "ridelist" : "68",
 "userdatalist" : "40",
 "paylist" : "39",
 "bikelist" : "38",
 "dashboardno" : "dashboard-1602210689902-91328",
 "projectno" : "proj-xtrace-7e654d5be9aeb17eb6abc78a83f22-cn-hangzhou",
 "customerCensusDay" : "179",
 "customerCensusMonth" : "178",
 "customerCensusTime" : "182",
 "siteCensusDay" : "181",
 "siteCensusMonth" : "180",
 "siteCensusTime" : "183",
 "noPassDetail" : "184",
 "agentdayform": "149",
 "controlDataAnalyze" : "185"
}


// WEBPACK FOOTER //
// ./src/config/xiaomaolv.js